import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getData, getStatus, getErrorMessage } from "@/store/slices/helpers/helpers";
import { clearData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiStatuses, apiUrls } from "@/store/api/constants";

export default function useGradeListMaster() {
  const [isCreateEditModalOpen, setIsCreateEditModalOpen] = useState(false);
  const [activeEditId, setActiveEditId] = useState(0);
  const { formatMessage } = useIntl();

  const dispatch = useDispatch();
  const state = useSelector((store) => store);

  const saveGradeListStatus = getStatus(state, apiKeys.saveGradeList, '');
  const updateGradeListStatus = getStatus(state, apiKeys.updateGradeList, '');
  const gradeListData = getData(state, apiKeys.gradeList, []);
  const gradeListStatus = getStatus(state, apiKeys.gradeList, '');
  const gradeListErrMsg = getErrorMessage(state, apiKeys.gradeList, '');
  const deleteGradeListStatus = getStatus(state, apiKeys.deleteGradeList, '');

  const getGradeList = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.gradeList,
      method: apiMethods.GET,
      key: apiKeys.gradeList,
      failureMsg: formatMessage({ id: "failed-to-get-gradelist-master" }),
    }))
  }, [dispatch, formatMessage])

  useEffect(() => {
    getGradeList()
  }, [dispatch, getGradeList]);

  useEffect(() => {
    if (deleteGradeListStatus === apiStatuses.succeeded) {
      getGradeList();
    }
  }, [deleteGradeListStatus, getGradeList])

  useEffect(() => () => {
    dispatch(clearData({ key: apiKeys.gradeList }));
  }, [dispatch]);

  const onRowEdit = useCallback((id) => {
    setIsCreateEditModalOpen(true);
    setActiveEditId(id);
  }, [])
  const closeModal = useCallback(() => {
    setIsCreateEditModalOpen(false);
    setActiveEditId(0);
  }, []);
  
  useEffect(() => {
    if (saveGradeListStatus === apiStatuses.succeeded) {
      closeModal(); 
      getGradeList();
    } 
  }, [saveGradeListStatus, closeModal, getGradeList]);

  useEffect(() => {
    if (updateGradeListStatus === apiStatuses.succeeded) {
      closeModal(); 
      getGradeList();
    } 
  }, [updateGradeListStatus, closeModal, getGradeList]);


  return useMemo(() => ({
    gradeListData,
    gradeListStatus,
    gradeListErrMsg,
    isCreateEditModalOpen,
    setIsCreateEditModalOpen,
    onRowEdit,
    activeEditId,
    closeModal
  }), [
    gradeListData,
    gradeListStatus,
    gradeListErrMsg,
    isCreateEditModalOpen,
    setIsCreateEditModalOpen,
    onRowEdit,
    activeEditId,
    closeModal
  ])
}
